import React from "react";
import TextInput from "../../../../../common/components/shared/textInput/textInput";
import Row from "../../../../../common/components/shared/row/row";
import {IconButton} from "@mui/material";
import {ReactComponent as RemoveIcon} from "../../../../../statics/icons/icon_remove.svg";
import {storesContext} from "../../../../../common/stores/stores";
import {IPriceStore} from "../../../../stores/priceStore";
import AddIcon from "@mui/icons-material/Add";
import i18n from "../../../../../i18n/i18n";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {observer} from "mobx-react";
import Validator from "../../../../../helpers/validator";

interface SingleParkingRateProps extends RouteComponentProps {
    priceIndex: number;
    parkingRateIndex: number;
    onRemoveAction: () => void;
    onAddAction: () => void;
}

class SingleParkingRate extends React.Component <SingleParkingRateProps, any> {
    static contextType = storesContext;

    constructor(props: any) {
        super(props);
    }

    get selectedParkingRate() {
        const priceStore = this.context.priceStore as IPriceStore;

        return priceStore.priceList[this.props.priceIndex].parkingRates[this.props.parkingRateIndex];
    }

    render(): React.ReactNode {
        return (
            <Row class="single-parking-rate flex-type gap-30">
                <TextInput
                    label={i18n.t("priceList.headers.parkingTime")}
                    validatedValue={this.selectedParkingRate.parkingTime}
                    testId={`parking-time-${this.props.priceIndex}-${this.props.parkingRateIndex}`}
                    offAutocomplete
                    onChange={() => {
                        const timeIsMultipleOfTwentyFourValidator = {
                            name: "timeIsMultipleOfTwentyFourValidator",
                            fn: (value: string) => {
                                if (this.selectedParkingRate.parkingFee.value && this.selectedParkingRate.parkingFee.value !== "" && Number.parseFloat(this.selectedParkingRate.parkingFee.value.toString()) > 0) {
                                    if (value) {
                                        return Validator.isMultipleOfNumber(Number.parseInt(value), 24);
                                    } else return true;
                                } else return true;
                            },
                            errorMessage: () => i18n.t("priceList.errors.isMultipleTimes")
                        };

                        this.selectedParkingRate.parkingTime.addValidators([timeIsMultipleOfTwentyFourValidator]);
                    }}
                />
                <TextInput
                    label={i18n.t("priceList.headers.parkingFee")}
                    validatedValue={this.selectedParkingRate.parkingFee}
                    testId={`parking-fee-${this.props.priceIndex}-${this.props.parkingRateIndex}`}
                    onChange={() => {
                        const priceStore = this.context.priceStore as IPriceStore;

                        const isOneFreeTime = {
                            name: "isOneFreeTime",
                            fn: () => {
                                let freeTime = 0;

                                priceStore.priceList[this.props.priceIndex].parkingRates.forEach((parkingRates) => {
                                    if (parkingRates.parkingFee.value && parkingRates.parkingFee.value.toString() === "0") ++freeTime;
                                });

                                return freeTime <= 1;
                            },
                            errorMessage: () => i18n.t("priceList.errors.isOneFreeTime")
                        };

                        const freeParkingRateAtIncorrectPosition = {
                            name: "freeParkingRateAtIncorrectPosition",
                            fn: () => {
                                if (this.selectedParkingRate.parkingFee.value && this.selectedParkingRate.parkingFee.value.toString() === "0" &&
                                this.props.parkingRateIndex !== 0) {
                                    return false;
                                }

                                return true;
                            },
                            errorMessage: () => i18n.t("priceList.errors.freeParkingRateAtIncorrectPosition")
                        };

                        this.selectedParkingRate.parkingFee.addValidators([isOneFreeTime, freeParkingRateAtIncorrectPosition]);
                        this.selectedParkingRate.parkingTime.addValidators([freeParkingRateAtIncorrectPosition]);
                    }}
                    onBlur={() => {
                        this.selectedParkingRate.parkingTime.validate();

                        if (this.selectedParkingRate.parkingTime.isValid) {
                            this.selectedParkingRate.parkingTime.clearValidation();
                        }
                    }}
                    offAutocomplete
                    type="number"
                    placeholderNumberType={i18n.t("priceFormat")}
                />
                {this.renderRemoveButton()}
                {this.renderAddButton()}
            </Row>
        );
    }

    private renderRemoveButton() {
        return (
            <IconButton
                className="remove-parking-rate-btn"
                onClick={() => this.props.onRemoveAction()}
                data-testid={`remove-parking-rate-${this.props.parkingRateIndex}`}
            >
                <RemoveIcon/>
            </IconButton>
        );
    }

    private renderAddButton() {
        const priceStore = this.context.priceStore as IPriceStore;

        if (priceStore.priceList[this.props.priceIndex].parkingRates.length === 1 || this.props.parkingRateIndex === priceStore.priceList[this.props.priceIndex].parkingRates.length - 1) {
            return (
                <IconButton
                    className="add-parking-rate-btn"
                    onClick={() => this.props.onAddAction()}
                    data-testid="add-parking-rate-btn"
                >
                    <AddIcon fontSize="large"/>
                </IconButton>
            );
        }
    }
}

export default withRouter(observer(SingleParkingRate));